import { createFileRoute } from '@tanstack/react-router';
import { NewSurveyPage } from '@/features/surveys/pages/NewSurveyPage';

export const Route = createFileRoute('/_authed/ops/surveys/new')({
  staticData: { help: 'surveys' },
  component: NewSurveyPage,
});
